import { Component } from '@theme/component';

class EstimatedDelivery extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.updateDates();
  }

  updatedCallback() {
    super.updatedCallback();
    this.updateDates();
  }

  updateDates() {
    const dispatchMin = parseInt(this.getAttribute('data-dispatch-min') || '1', 10);
    const dispatchMax = parseInt(this.getAttribute('data-dispatch-max') || '2', 10);
    const deliveryMin = parseInt(this.getAttribute('data-delivery-min') || '5', 10);
    const deliveryMax = parseInt(this.getAttribute('data-delivery-max') || '7', 10);

    const today = new Date();

    const formatDate = (date) => {
      const day = date.getDate();
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const month = monthNames[date.getMonth()];
      // Format as "25 Jul" to match Liquid date formatting
      return `${day} ${month}`;
    };

    const addDays = (date, days) => {
      const result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    };

    const orderDate = today;
    const dispatchStart = addDays(today, dispatchMin);
    const dispatchEnd = addDays(today, dispatchMax);
    const deliveryStart = addDays(today, dispatchMax + deliveryMin);
    const deliveryEnd = addDays(today, dispatchMax + deliveryMax);

    // Update the dates inside the timeline steps
    const orderEl = this.querySelector('[data-date="order"]');
    if (orderEl) orderEl.textContent = formatDate(orderDate);

    const dispatchEl = this.querySelector('[data-date="dispatch"]');
    if (dispatchEl) dispatchEl.textContent = `${formatDate(dispatchStart)} - ${formatDate(dispatchEnd)}`;

    const deliveryEl = this.querySelector('[data-date="delivery"]');
    if (deliveryEl) deliveryEl.textContent = `${formatDate(deliveryStart)} - ${formatDate(deliveryEnd)}`;


  }
}

if (!customElements.get('estimated-delivery')) {
  customElements.define('estimated-delivery', EstimatedDelivery);
}
